module.exports = __webpack_public_path__ + "img/IMG-20200901-WA0007.c14b1e54.jpg";